


export function createPageUrl(pageName: string) {
    return '/' + pageName.toLowerCase().replace(/ /g, '-');
}

/**
 * Get CSRF token from cookie
 * Used for secure cookie-based authentication
 * @returns {string|undefined} CSRF token if available
 */
export function getCsrfToken(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const token = document.cookie
    .split('; ')
    .find(row => row.startsWith('csrf_token='))
    ?.split('=')[1];
  return token ? decodeURIComponent(token) : undefined;
}